// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-2r83w","button_default":"button_default-Ki7a9"};